// components
import SvgIconStyle from "../../../components/SvgIconStyle";
import Iconify from "../../../components/Iconify";
//
import { useTranslation } from "react-i18next";

// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

const ICONS = {
  user: getIcon("ic_user"),
  ecommerce: getIcon("ic_ecommerce"),
  analytics: getIcon("ic_analytics"),
  dashboard: getIcon("ic_dashboard"),
  newProject: getIcon("ic_kanban"),
};

export default function NavSpecialAdminConfig(plannerLink) {
  const { t } = useTranslation();

  return [
    // GENERAL
    // ----------------------------------------------------------------------
    {
      subheader: t("navbars.left.instruments.label"),
      items: [
        {
          title: t("navbars.left.instruments.items.planner"),
          path: plannerLink,
          icon: ICONS.dashboard,
        },
        {
          title: t("navbars.left.instruments.items.quotations"),
          path: "/dashboard/quotations",
          icon: ICONS.ecommerce,
        },
        {
          title: t("navbars.left.instruments.items.new_project"),
          path: "/dashboard/new",
          icon: (
            <Iconify
              icon={`material-symbols:library-add`}
              width={28}
              height={28}
            />
          ),
        },
      ],
    },

    // MANAGEMENT
    // ----------------------------------------------------------------------
    {
      subheader: t("navbars.left.management.label"),
      items: [
        {
          title: t("navbars.left.management.items.quotations"),
          path: "/admin/quotations",
          icon: ICONS.ecommerce,
        },
      ],
    },
  ];
}
